import { Fragment, useState } from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import { Href, ReceiveAudioCallTitle } from "../../../../Constants/Constants";
import { ReceiveAudioCallData } from "../../../../Data/Bonus/Elements";
import { dynamicImage, Image } from "../../../../Utils";

const ReceiveAudioCall = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <Fragment>
      <Button color="primary" className="fonts font_label" onClick={toggle}>{ReceiveAudioCallTitle}</Button>
      <Modal isOpen={modal} fade toggle={toggle} centered>
        <ModalBody className="p-0">
          <div className="audiocall2 call-modal bg-size custom-modal-1" >
            <Image className="bg-img" src={dynamicImage("avtar/big/audiocall.jpg")} alt="Avatar" style={{ display: "none" }} />
            <div className="center-con text-center">
              <div>00:00:00</div>
              <div className="title2">Josephin Water</div>
              <h6>Los Angeles, California</h6>
              <ul>
                {ReceiveAudioCallData.map((action, index) => (
                  <li key={index}>
                    {action.color ? (
                      <Button color={action.color} size="xl" tag="a" className={`icon-btn button-effect ${action.className}`} onClick={toggle} href={Href}>{action.icon}                      </Button>
                    ) : (
                      <a className={`icon-btn btn-light button-effect ${action.className}`} href={Href}>{action.icon}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default ReceiveAudioCall;
